import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_ctx.suggestions)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "mt-5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "default_card large" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                headers: _ctx.headers,
                items: _ctx.suggestions,
                class: "table",
                "fixed-header": "",
                "max-height": "60vh",
                "hide-default-footer": ""
              }, {
                item: _withCtx(({ item }) => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.getType(item)), 1),
                    _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.getAccountableAccountName(item)), 1),
                    _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.getAccountableAccountDescription(item)), 1),
                    _createElementVNode("td", _hoisted_4, _toDisplayString(item.count), 1),
                    _createElementVNode("td", _hoisted_5, _toDisplayString(item.status), 1),
                    _createElementVNode("td", _hoisted_6, [
                      (
                                    item.status === 'VALIDATED' ||
                                    item.status === 'PENDING_VALIDATION'
                                )
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            size: "small",
                            variant: "text",
                            color: "red",
                            onClick: ($event: any) => (_ctx.invalidate(item))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                  _createTextVNode("$highlight_off")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (
                                    item.status === 'INVALIDATED' ||
                                    item.status === 'PENDING_VALIDATION'
                                )
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            size: "small",
                            variant: "text",
                            color: "green",
                            onClick: ($event: any) => (_ctx.validate(item))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                  _createTextVNode("$check_circle_outline")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["headers", "items"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}